/* eslint-disable @typescript-eslint/no-explicit-any */
import $api from "shared/hooks/api";

export const setAuthToken = (accessToken: string, refreshToken: string) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
    //$api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    $api.defaults.headers.common["Authorization"] = "";
    window.location.href = "/auth";
  }
};
